import {Box, Chip} from '@mui/material';

type Props = {
  requestCostUsd: string | null;
  sessionCostUsd: string | null;
  requestLabel?: string;
  sessionLabel?: string;
  showSessionCost?: boolean;
};

export const formatUsdCost = (value: string | null) => {
  if (value === null) return '--';

  const [integerPart, decimalPart = ''] = value.split('.');
  const cents = BigInt(`${integerPart}${decimalPart.slice(0, 2).padEnd(2, '0')}`);
  const hasFractionBeyondCents = /[1-9]/.test(decimalPart.slice(2));
  const roundedCents = cents + (hasFractionBeyondCents ? 1n : 0n);
  const digits = roundedCents.toString().padStart(3, '0');
  return `${digits.slice(0, -2)}.${digits.slice(-2)}`;
};

const AgentCostBadge = ({
  requestCostUsd,
  sessionCostUsd,
  requestLabel = 'Cost',
  sessionLabel = 'Cost',
  showSessionCost = true
}: Props) => (
  <Box sx={{display: 'flex', gap: 1, flexWrap: 'wrap', mt: 0.75}}>
    <Chip
      size="small"
      variant="outlined"
      label={`${requestLabel} $${formatUsdCost(requestCostUsd)}`}
    />
    {showSessionCost && (
      <Chip
        size="small"
        variant="outlined"
        label={`${sessionLabel} $${formatUsdCost(sessionCostUsd)}`}
      />
    )}
  </Box>
);

export default AgentCostBadge;
